<template>
<div v-if="history">
    <div class="container">
    <div class="section-heading-md pb-3">Recently viewed products</div>
    </div>
    <products category_id="continue" container="container" product_id=""></products>
</div>
</template>

<script>
export default {

  data() {
    return {
      history: false,
    };
  },

  mounted() {
    this.checkProducts();
  },

  methods: {

    checkProducts() {
      if(localStorage.getItem('history')) {
        this.history = true;
      }
    },

  },
};
</script> 
